export default __webpack_public_path__ + "static/media/users-white.d03a1894.svg";